<template>
<div class="chapter">
<div class="inner_page">
<div class="foreword" id="foreword">
<div class="chapterHead">
<h2 class="chapterTitle-F">FOREWORD</h2>
</div>
<p class="centerImage"><img alt="image" id="img8" src="images/img8.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// VulcanTestPilot_foreword.vue?c74e83ac